import React from 'react';

interface LockIconProps {
  className?: string;
  color?: string;
  size?: number;
}

export const LockIcon: React.FC<LockIconProps> = (props) => {
  const { className, color = '#23375E', size = 36 } = props;
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6C20.4716 6 22.5 8.02843 22.5 10.5V15H13.5V10.5C13.5 8.02843 15.5284 6 18 6ZM25.5 15V10.5C25.5 6.37157 22.1284 3 18 3C13.8716 3 10.5 6.37157 10.5 10.5V15H9C7.34315 15 6 16.3431 6 18V30C6 31.6569 7.34315 33 9 33H27C28.6569 33 30 31.6569 30 30V18C30 16.3431 28.6569 15 27 15H25.5ZM9 18H27V30H9V18Z"
        fill={color}
      />
    </svg>
  );
};
